import { t } from "@/i18n-js/instance";
import { EventsWrapper } from "../components/EventsWrapper";
import { NewsWrapper } from "../components/NewsWrapper";
import { CircleAcademyBanner } from "../components/common/CircleAcademyBanner";
import { ExploreButton } from "../components/common/ExploreButton";
import { CIRCLE_COMMUNITY_URL, CIRCLE_PARTNERS_URL } from "../constants";

export const ExplorePage = () => (
  <div className="scrollbar-hide bg-secondary flex h-full flex-col overflow-auto">
    <div className="m-4 mb-2">
      <CircleAcademyBanner />
      <NewsWrapper />
    </div>
    <hr className="border-border-default" />
    <div className="mx-4 mb-2">
      <EventsWrapper />
    </div>
    <hr className="border-border-default" />
    <div className="m-4 mb-6">
      <ExploreButton
        text={t("help_widget.explore_page.circle_community")}
        onClick={() => {
          window.open(CIRCLE_COMMUNITY_URL, "_blank");
        }}
      />
      <ExploreButton
        text={t("help_widget.explore_page.circle_partners")}
        onClick={() => {
          window.open(CIRCLE_PARTNERS_URL, "_blank");
        }}
      />
    </div>
  </div>
);
